import { useEffect, useState } from "react";
import { useServerHealthCheck } from "./queries/useServerHealthCheck";
import { AxiosError } from "axios";

const useOnlineStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  const {
    isSuccess: isHealthCheckSuccess,
    isError: isHealthCheckError,
    isPending: isHealthCheckPending,
    isFetched: isHealthCheckFetched,
    error: healthCheckError = {} as any,
  } = useServerHealthCheck();

  const isHealthCheckNetworkError = healthCheckError?.code === AxiosError.ERR_NETWORK;

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return {
    isOnline: isHealthCheckSuccess || !isHealthCheckFetched || (isOnline && !isHealthCheckPending && (!isHealthCheckError || isHealthCheckNetworkError)),
    isNavigatorOnline: isOnline,
    isServerOnline: !isHealthCheckError,
  };
};

export default useOnlineStatus;
